import { bookingTypes } from "Library/Constants";
import images from "../../Assets/images";
export const extensionLogo: any = {
  pdf: images.PDFIcon,
  csv: images.CSVlogo,
  xlsx: images.CSVlogo,
  xls: images.CSVlogo,
  doc: images.CSVlogo,
  zip: images.CSVlogo,
  docx: images.CSVlogo,
  png: images.imageIcon,
  jpeg: images.imageIcon,
  jpg: images.imageIcon,
  svg: images.imageIcon,
};

export const deliveryTypeIcon: any = {
  [bookingTypes.DELIVERY]: images.DeliveryIcon,
  [bookingTypes.RECURRING]: images.recurring,
  [bookingTypes.MULTI_VEHICLE]: images.multiVehicle,
  [bookingTypes.RESOURCE_ONLY]: images.resource,
};
